import { INode } from 'shared/types/tree'
import { Button } from '@mui/material'
import * as React from 'react'
import { downloadJson } from 'shared/utils/fileExport'

export function DownloadTreeButton({ tree }: { tree: INode | null }) {
  if (!tree) return null

  function downloadTree() {
    if (!tree) return
    downloadJson(tree.title, tree)
  }

  return (
    <Button variant="outlined" onClick={downloadTree}>
      Download
    </Button>
  )
}
